export const asRightArrow = {
  data: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M10.7459 7.33566H3.40592C3.03926 7.33566 2.73926 7.63566 2.73926 8.00233C2.73926 8.369 3.03926 8.669 3.40592 8.669H10.7459V9.86233C10.7459 10.1623 11.1059 10.309 11.3126 10.0957L13.1659 8.23566C13.2926 8.10233 13.2926 7.89566 13.1659 7.76233L11.3126 5.90233C11.1059 5.689 10.7459 5.84233 10.7459 6.13566V7.33566Z" fill="#818F99"/>
  </svg>    
  `,
  name: 'rightarrow',
};
